import {Component, Input, OnInit} from '@angular/core';
import {LoginService} from '../../../../../../app-core/service/login.service';
import {Usuario} from '../../../../../../app-core/model/cadastros/usuario.model';
import {DeprecatedSharedUtilsModule} from '../../../../../../app-core/utils/deprecated-shared-utils-module';
import {UiModule} from '../../../../../../app-core/utils/ui/ui.module';

@Component({
    selector: 'profile-widget',
    templateUrl: './profile-widget.component.html',
    imports: [
        DeprecatedSharedUtilsModule,
        UiModule
    ],
    styleUrls: ['./profile-widget.component.scss']
})
export class ProfileWidgetComponent implements OnInit {
   usuario: Usuario;
   @Input() nomeUsuario: string;
   @Input() empresaOuUnidade: string;
   @Input() links: {
      titulo: string,
      corpo: string,
      rota: string,
      icon: string
   }[];
   @Input() alteraraSenha = true;

   constructor(public loginService: LoginService) {
   }

   ngOnInit() {
      this.usuario = this.loginService.getUser();
   }

   logout() {
      this.loginService.logout();
   }
}
